<div class="d-grid justify-center align-items-center mt-5" style="grid-template-rows: repeat(3, 0.5fr); gap: 20px;">
    <button class="btn btn-primary" (click)="connectOutlook()">Conectar con Outlook</button>
    <button class="btn btn-primary" (click)="openEventDetails()">Ver Eventos de Outlook</button>
    <button class="btn btn-primary" (click)="openMailModal()">Envio de Mails</button>
</div>
